import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link as LinkIcon, Copy } from "lucide-react";
import { FREEMIUM_TOOLS, LEVELS, copyText } from "./shared";

export function LinksTab() {
  const [source, setSource] = useState("");
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const cleanSource = source.trim().replace(/\s+/g, "-");
  const buildUrl = (path, level) => `${origin}${path}?level=${level}${cleanSource ? `&utm_source=${encodeURIComponent(cleanSource)}` : ""}`;
  const buildIframe = (url) => `<iframe src="${url}" width="100%" height="720" style="border:0;border-radius:16px" allow="clipboard-write"></iframe>`;

  return (
    <div className="space-y-5" data-testid="admin-links">
      <Card className="p-4 rounded-2xl border-border bg-navy/5">
        <p className="text-sm text-navy">Public freemium links for your showcase site. Each guest gets <b>5 free messages per tool</b>, then is invited to create an account. The <code className="text-orange">?level=</code> parameter selects the Undergraduate or Postgraduate agent.</p>
      </Card>

      <Card className="p-5 rounded-2xl border-border" data-testid="links-source-card">
        <h3 className="font-display font-extrabold italic text-navy mb-1">Track a source (optional)</h3>
        <p className="text-sm text-muted-foreground mb-3">Add a label (e.g. <code className="text-orange">site-vitrine</code>, <code className="text-orange">newsletter</code>) to tag these links with <code className="text-orange">utm_source</code>. Conversions per source appear in the Statistics tab.</p>
        <Input data-testid="links-source-input" value={source} onChange={(e) => setSource(e.target.value)} placeholder="site-vitrine" className="h-11 rounded-xl max-w-xs" />
      </Card>

      {FREEMIUM_TOOLS.map((tool) => (
        <Card key={tool.key} className="p-6 rounded-2xl border-border" data-testid={`links-tool-${tool.key}`}>
          <div className="flex items-center gap-2 mb-4">
            <LinkIcon className="h-5 w-5 text-orange" />
            <h3 className="font-display font-extrabold italic text-navy">{tool.label}</h3>
          </div>
          <div className="space-y-4">
            {LEVELS.map((lvl) => {
              const url = buildUrl(tool.path, lvl.key);
              return (
                <div key={lvl.key} className="space-y-2">
                  <div className="flex items-center gap-2">
                    <Badge variant="secondary">{lvl.label}</Badge>
                  </div>
                  <div className="flex items-center gap-2">
                    <Input readOnly value={url} data-testid={`links-url-${tool.key}-${lvl.key}`} className="h-10 rounded-xl font-mono text-xs bg-secondary" onFocus={(e) => e.target.select()} />
                    <Button size="sm" variant="outline" className="rounded-full shrink-0" data-testid={`links-copy-${tool.key}-${lvl.key}`} onClick={() => copyText(url)}>
                      <Copy className="h-3.5 w-3.5 mr-1" /> Link
                    </Button>
                    <Button size="sm" className="rounded-full shrink-0 bg-navy hover:bg-navy-deep text-white" data-testid={`links-embed-${tool.key}-${lvl.key}`} onClick={() => copyText(buildIframe(url))}>
                      <Copy className="h-3.5 w-3.5 mr-1" /> Embed
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        </Card>
      ))}
    </div>
  );
}
